import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";
import { CustomerForm } from "@/features/dashboard/clientes/components/CustomerForm";

export const Route = createFileRoute("/_private/dashboard/_base/clientes/cadastrar/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Stack>
      <DashboardComponents.Title>Cadastrar Cliente</DashboardComponents.Title>

      <CustomerForm />
    </Stack>
  );
}
